import React from 'react';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import Points from '../../Models/Points';
import { Header } from '../Common';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from "react-toastify";
import {withTranslation} from "react-i18next";
import {withdrawCharge} from "../../Config/constants";
class MyPoints extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('GLOBAL.PLEASE_LOGIN'));
            this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            modal: false,
            nestedModal: false,
            closeAll: false,
            points: [],
            status: '',
            com_point: '',
            month_point: '',
            ammount: '',
            rem_point: '',
            logged_user_id: '',
            history: ''
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.toggle = this.toggle.bind(this);
        this.toggleNested = this.toggleNested.bind(this);
        this.toggleAll = this.toggleAll.bind(this);
        this.state.logged_user_id = logged_user.id;
        this.getMyPoints();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    Notify(a) {
        toast(a, {
            position: "top-center"
        });
    }
    getMyPoints() {
        Points.getPoints(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ points: res.data.payload })
                this.setState({ com_point: parseInt(this.state.points.total_amount) })
                this.setState({ month_point: parseInt(res.data.last) })
                this.setState({ rem_point: parseInt(this.state.points.remaining_amount) })
            } else {
                this.setState({ com_point: 0 })
                this.setState({ month_point: 0 })
                this.setState({ rem_point: 0 })
            }

        })
        Points.getHistory(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ history: res.data.history })
            }
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleNested() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: false
        });
    }

    toggleAll() {
        this.setState({
            nestedModal: !this.state.nestedModal,
            closeAll: true
        });
    }

    // errorMessage() {
    //     return (
    //         <div>
    //             <span style={{ color: "red", fontSize: '12px' }}>Your amount must be between {this.state.rem_point} {this.props.t('SELLER_MY_POINTS.YEN')}.</span>
    //         </div>
    //     )
    // }
    check(e) {
        e.preventDefault();
        var f = 0;
        Points.getLegality(this.state.logged_user_id).then(res => {
            console.log(res.data.status)
            if(res.data.status == 200){
                f = 0;
            } else {
                f = 1;
            }
            if (f === 1) {
                this.Notify(this.props.t('SELLER_MY_POINTS.ENTER_ALL_INFO_ALERT'))
            } else if (this.state.rem_point < this.state.ammount) {
                this.Notify(`${this.props.t('SELLER_MY_POINTS.AMOUNT_REQUESTED_ALERT_PART1')} ${this.state.rem_point}${this.props.t('SELLER_MY_POINTS.AMOUNT_REQUESTED_ALERT_PART2')}`)
            } else if (this.state.ammount < 100) {
                alert(this.props.t('SELLER_MY_POINTS.300_OR_MORE_ALERT'))
                // this.Notify(this.props.t('SELLER_MY_POINTS.300_OR_MORE_ALERT'))
            } else {
                this.toggleNested();
            }
        })
    }

    handleSubmit(e) {
        e.preventDefault();
        var x = JSON.parse(localStorage.getItem('info'))
        if (this.state.rem_point < this.state.ammount) {
            alert(`${this.props.t('SELLER_MY_POINTS.AMOUNT_REQUESTED_ALERT_PART1')} ${this.state.rem_point}${this.props.t('SELLER_MY_POINTS.AMOUNT_REQUESTED_ALERT_PART2')}`)
        } else if (this.state.ammount < 100) {
            alert(this.props.t('SELLER_MY_POINTS.300_OR_MORE_ALERT'))
        } else {
            let data = {
                id: x.id,
                amount: this.state.ammount
            }
            Points.WithdrawPoints(data).then(res => {
                if (res.data.message === 'Success') {
                    alert(this.props.t('SELLER_MY_POINTS.SUCCESS_ALERT'))
                    this.toggleAll.bind(this)
                    window.location.reload()
                }
            })
        }
    }

    withdrawPoints() {
        if (this.state.rem_point < 100) {
            return (
                <div>
                    <Button color="" className="" style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>{this.props.t('SELLER_MY_POINTS.APPLY_BTN')}</Button>
                </div>
            )
        } else {
            return (
                <Button color="" className="" onClick={this.toggle} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>{this.props.t('SELLER_MY_POINTS.APPLY_BTN')}</Button>
            )
        }
    }

    apply() {
        var p = this.state.rem_point
        return (
            <div className="">
                {this.withdrawPoints()}
                {/* <Button color="" className="" onClick={this.toggle} style={{ color: '#444', cursor: 'pointer', height: '35px', border: "1px solid #ccc" }}>{this.props.t('SELLER_MY_POINTS.APPLY_BTN')}</Button> */}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>{this.props.t('SELLER_MY_POINTS.SELLER_MY_POINTS_TITLE')}</ModalHeader>
                    <ModalBody>
                        <div className="container">
                            <Form onSubmit={this.handleSubmit.bind(this)}>
                                <FormGroup>
                                    <Label for="exampleEmail">{this.props.t('SELLER_MY_POINTS.AMOUNT')}</Label>
                                    <Input type="number" name="number" id="exampleEmail" value={this.state.ammount} onChange={this.updateValue.bind(this, 'ammount')} />
                                    {/* {this.errorMessage()} */}

                                </FormGroup>
                            </Form>
                        </div>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.toggle}>{this.props.t('SELLER_MY_POINTS.CANCEL_BTN')}</Button>
                            <Button style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} onClick={this.check.bind(this)}>{this.props.t('SELLER_MY_POINTS.CONFIRM_BTN')}</Button>
                        </ModalFooter>
                        <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} onClosed={this.state.closeAll ? this.toggle : undefined}>
                            <ModalHeader>{this.props.t('SELLER_MY_POINTS.CONFIRM_APPLICATION')}</ModalHeader>
                            <ModalBody><Label for="exampleEmail">{this.props.t('SELLER_MY_POINTS.AMMOUNT_APPLIED')} </Label> {this.state.ammount} {this.props.t('SELLER_MY_POINTS.YEN')}</ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggleNested}>{this.props.t('SELLER_MY_POINTS.EDIT_BTN')}</Button>
                                <Button style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1" }} onClick={this.handleSubmit.bind(this)} >{this.props.t('SELLER_MY_POINTS.SUBMIT_BTN')}</Button>{' '}
                            </ModalFooter>
                        </Modal>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font" style={{textAlign:'left', width: '100%',fontSize:'20px' }}>
                                    {this.props.t('SELLER_MY_POINTS.SELLER_MY_POINTS_TITLE')}
                                </div>
                                <div style={{ border: "1px solid #bababa", paddingTop: "7%", paddingLeft: "2%", paddingRight: "2%" }}>
                                    <div className="center">
                                        {this.props.t('SELLER_MY_POINTS.BALANCE')}
                                    </div>
                                    <div className="center">
                                        <h3>{this.state.rem_point} P</h3>
                                    </div>
                                    <div>&nbsp;</div>
                                    <div className="center">{this.apply()}</div>
                                    <div>&nbsp;</div>
                                    <div className=" center">
                                        <div className="col-md-2"></div>
                                        <div className="" >
                                            <div className="col">
                                                <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                    {this.props.t('SELLER_MY_POINTS.CURRENT_SALES')}<br />
                                                    <h4>{this.state.month_point} p</h4>
                                                </div>
                                                <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                    {this.props.t('SELLER_MY_POINTS.TOTAL_SALES')}<br />
                                                    <h4>{this.state.com_point} p</h4>
                                                </div>
                                            </div>
                                            <div>&nbsp;</div>
                                            <div className="font_12">
                                                {this.props.t('SELLER_MY_POINTS.TEXT1')}
                                                </div>
                                            <div className="font_12">
                                                {this.props.t('SELLER_MY_POINTS.TEXT2')}
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                    <div className="">
                                        <div style={{ fontSize: "20px", padding: "3%", borderBottom: "1px solid #ddd" }}>
                                            {this.props.t('SELLER_MY_POINTS.RULES_TITLE')}
                                                </div>
                                        <div>
                                            <span className="font_12">
                                                {this.props.t('SELLER_MY_POINTS.RULES_TEXT1')}
                                                    </span>
                                            <div>&nbsp;</div>
                                            <span className="font_12">
                                                {this.props.t('SELLER_MY_POINTS.RULES_TEXT2')}
                                                    </span>
                                            <div>&nbsp;</div>
                                            <span className="font_12">
                                                {this.props.t('SELLER_MY_POINTS.RULES_TEXT3')}<br />
                                            </span>
                                            <div>&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                <div>&nbsp;<br /></div>
                                <div style={{ height: "auto", border: "1px solid #bababa", padding: "3%" }}>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <span style={{ fontSize: "20px" }}><b>{this.props.t('SELLER_MY_POINTS.APPLICATION_HISTORY')}</b></span>
                                    </div>
                                    <div>&nbsp;<br /></div>
                                    {/* <div>
                                        {(() => {
                                            if (this.state.history.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div className="col-md-12 row" style={{ borderBottom: "1px solid #bababa", padding: "1%", fontSize: "13px" }}>
                                                        <div className="col-md-5" style={{ textAlign: "left" }}>
                                                            {this.props.t('SELLER_MY_POINTS.APPLICATION_DATE')}
                                                                </div>
                                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                                            {this.props.t('SELLER_MY_POINTS.AMOUNT')}
                                                                </div>
                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                            {this.props.t('SELLER_MY_POINTS.STATUS')}
                                                                </div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>*/}
                                    <div style={{ fontSize: "13px" }}>
                                        {(() => {
                                            if (this.state.history.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div>
                                                        {this.state.history.map(group =>
                                                            <div className="p-2">
                                                                <div className="col-12" style={{ textAlign: "left" }}>
                                                                    req amount: {group.requested_amount} {this.props.t('SELLER_MY_POINTS.YEN')}
                                                                </div>
                                                                <div className="col-12" style={{ textAlign: "left" }}>
                                                                    receivable amount: {group.requested_amount - withdrawCharge(group.requested_amount)} {this.props.t('SELLER_MY_POINTS.YEN')}
                                                                </div>
                                                                <div className="row col-12">
                                                                    <div className="col-7" style={{ textAlign: "left" }}>
                                                                        {group.created_at}
                                                                    </div>
                                                                    <div className="col-5" style={{ textAlign: "left" }}>
                                                                        {(() => {
                                                                            if (group.request_status === 'PENDING') {
                                                                                return (
                                                                                    <span>{this.props.t('SELLER_MY_POINTS.STATUS_PENDING')}</span>
                                                                                )
                                                                            } else if (group.request_status === 'DEPOSITED') {
                                                                                return (
                                                                                    <span>{this.props.t('SELLER_MY_POINTS.STATUS_COMPLETE')}</span>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <span>{this.props.t('SELLER_MY_POINTS.REJECTION')}</span>
                                                                                )
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ToastContainer />
                        <Footer />
                    </div>
                </div>
            )
        }
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font " style={{ width: '100%',textAlign:'left' }}>
                                            {this.props.t('SELLER_MY_POINTS.SELLER_MY_POINTS_TITLE')}
                                    </div>
                                        <div style={{ border: "1px solid #bababa", paddingTop: "7%", paddingLeft: "2%", paddingRight: "2%" }}>
                                            <div className="center">
                                                {this.props.t('SELLER_MY_POINTS.BALANCE')}
                                        </div>
                                            <div className="center">
                                                <h3>{this.state.rem_point} P</h3>
                                            </div>
                                            <div>&nbsp;</div>
                                            {/* <div className="center">{this.preCheck.bind(this)}</div> */}
                                            <div className="center">{this.apply()}</div>
                                            <div>&nbsp;</div>
                                            <div className="row center">
                                                <div className="col-md-2"></div>
                                                <div className="col-md-8" style={{ borderTop: "1px solid #ddd" }}>
                                                    <div className="col-md-0 row">
                                                        <div className="col-md-6" style={{ borderRight: "1px solid #ddd", textAlign: "center", padding: "3%" }}>
                                                            {this.props.t('SELLER_MY_POINTS.CURRENT_SALES')}<br />
                                                            <h4>{this.state.month_point} p</h4>
                                                        </div>
                                                        <div className="col-md-6" style={{ textAlign: "center", padding: "3%" }}>
                                                            {this.props.t('SELLER_MY_POINTS.TOTAL_SALES')}<br />
                                                            <h4>{this.state.com_point} p</h4>
                                                        </div>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div className="font_12">
                                                        {this.props.t('SELLER_MY_POINTS.TEXT1')}
                                                    </div>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                            <div className="col-md-12">
                                                <div style={{ fontSize: "20px", padding: "1%", borderBottom: "1px solid #ddd" }}>
                                                    {this.props.t('SELLER_MY_POINTS.RULES_TITLE')}
                                            </div>
                                                <br />
                                                <div>
                                                    <span className="font_12">
                                                        {this.props.t('SELLER_MY_POINTS.RULES_TEXT1')}
                                                </span>
                                                    <div>&nbsp;</div>
                                                    <span className="font_12">
                                                        {this.props.t('SELLER_MY_POINTS.RULES_TEXT2')}
                                                </span>
                                                    <div>&nbsp;</div>
                                                    <span className="font_12">
                                                        {this.props.t('SELLER_MY_POINTS.RULES_TEXT3')}<br />
                                                    </span>
                                                    <div>&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>&nbsp;<br /></div>
                                        <div style={{ height: "auto", border: "1px solid #bababa", padding: "3%" }}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <span style={{ fontSize: "24px" }}><b>{this.props.t('SELLER_MY_POINTS.APPLICATION_HISTORY')}</b></span>
                                            </div>
                                            <div>&nbsp;<br /></div>
                                            <div>
                                                {(() => {
                                                    if (this.state.history.length === 0) {
                                                        return (
                                                            <div></div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div className="col-md-12 row" style={{ borderBottom: "1px solid #bababa", padding: "1%", fontSize: "14px" }}>
                                                                <div className="col-md-4" style={{ textAlign: "left" }}>
                                                                    {this.props.t('SELLER_MY_POINTS.APPLICATION_DATE')}
                                                                </div>
                                                                <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                    {this.props.t('SELLER_MY_POINTS.AMOUNT')}
                                                                </div>
                                                                <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                    {this.props.t('SELLER_MY_POINTS.AMOUNT')}
                                                                </div>
                                                                <div className="col-md-2" style={{ textAlign: "left" }}>
                                                                    {this.props.t('SELLER_MY_POINTS.STATUS')}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                            <div>&nbsp;<br /></div>
                                            <div style={{ fontSize: "14px" }}>
                                                {(() => {
                                                    if (this.state.history.length === 0) {
                                                        return (
                                                            <div></div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div>
                                                                {this.state.history.map(group =>
                                                                    <div className="col-md-12 row">
                                                                        <div className="col-md-4" style={{ textAlign: "left" }}>
                                                                            {group.created_at}
                                                                        </div>
                                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                            {group.requested_amount} {this.props.t('SELLER_MY_POINTS.YEN')}
                                                                        </div>
                                                                        <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                            {group.requested_amount - withdrawCharge(group.requested_amount)} {this.props.t('SELLER_MY_POINTS.YEN')}
                                                                        </div>
                                                                        <div className="col-md-2" style={{ textAlign: "left" }}>
                                                                            {(() => {
                                                                                if (group.request_status === 'PENDING') {
                                                                                    return (
                                                                                        <span>{this.props.t('SELLER_MY_POINTS.STATUS_PENDING')}</span>
                                                                                    )
                                                                                } else if (group.request_status === 'DEPOSITED') {
                                                                                    return (
                                                                                        <span>{this.props.t('SELLER_MY_POINTS.STATUS_COMPLETE')}</span>
                                                                                    )
                                                                                } else {
                                                                                    return (
                                                                                        <span>{this.props.t('SELLER_MY_POINTS.REJECTION')}</span>
                                                                                    )
                                                                                }
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ToastContainer />
                        <Footer />
                    </div>
                </div>
            )
        }
    }
}
export { MyPoints }
MyPoints = withTranslation('seller')(MyPoints);
